import { ReportTemplate, ReportTemplateWatchlistMeta } from 'dashboard/models/report-template';
import { ReportTemplateVersion } from 'dashboard/models/report-template-version';
import Action from 'lib/interfaces/Action';

export type ReportTemplateActions =
  | Action<ReportTemplateActionType.ClearReportTemplate>
  | Action<ReportTemplateActionType.SetReportTemplate, SetReportTemplatePayload>;

export enum ReportTemplateActionType {
  ClearReportTemplate = 'report-template/CLEAR_REPORT_TEMPLATE',
  SetReportTemplate = 'report-template/SET_REPORT_TEMPLATE',
}

export function clearReportTemplate(): Action<ReportTemplateActionType.ClearReportTemplate> {
  return { type: ReportTemplateActionType.ClearReportTemplate };
}

interface SetReportTemplatePayload {
  reportTemplate: ReportTemplate;
  latestPublishedVersion?: ReportTemplateVersion;
  reportTemplateVersions?: ReportTemplateVersion[];
  meta?: ReportTemplateWatchlistMeta;
}

export function setReportTemplate(
  reportTemplate: ReportTemplate,
  latestPublishedVersion?: ReportTemplateVersion,
  meta?: ReportTemplateWatchlistMeta,
): Action<ReportTemplateActionType.SetReportTemplate, SetReportTemplatePayload> {
  return {
    payload: {
      reportTemplate,
      latestPublishedVersion,
      meta,
    },
    type: ReportTemplateActionType.SetReportTemplate,
  };
}
